<template>
<div class="outpatientServiceContent" v-show="getShow">
  <div class="topBar">
      <div class="title">
        门诊
        <div class="deleteDraftBtn" v-if="patient && patient.visitState ==='00'" @click="deletDraft()">删除草稿</div>
      </div>
    <div class="DoBox" v-if="patient">
      <div class="intelligentDiagnosisBtn" v-if="(patient && patient.visitState!=='02' ||  isEdit) && isShowAiDiagnosis" @click="aiDiagnosis()">智能诊断</div>
      <div class="finishDiagnosisBtn" v-if="patient && (patient.visitState ==='00' || patient.visitState ==='01') &&  isShowFinishReception" @click="finishReception">完成接诊</div>
      <div class="finishDiagnosisBtn" v-if="patient && patient.visitState ==='02' && !isEdit && isShowSave" @click="updateCOntent()">修改</div>
      <div class="finishDiagnosisBtn" v-if="patient && patient.visitState ==='02' && isEdit && isShowSave" @click="save()">保存</div>
      <div class="finishDiagnosisBtn" v-if="patient && patient.visitState ==='02' && isEdit" @click="cancelEdit()">取消</div>
    </div>
  </div>
  <div class="contentBoy" v-if="patient">
    <div class="contentBox">
      <div class="head" >
        <nameGenderAgePhonenumberPiece @refresh-list="refreshList" ref="nameGenderRef" :userInfoData="patient" @updateUserInfo="updateUserInfo"/>
        <doctorInfo/>
      </div>
      <div class="content">
        <medicalRecord ref="medicalRecordRef" :userInfoData="patient" @set-age-error="setAgeError" @set-gender-error="setGenderError" />
      </div>
    </div>
  </div>


</div>
</template>

<script>
import nameGenderAgePhonenumberPiece from "@/views/outpatientDoctorWorkstation/outpatientService/components/outpatientServiceContent/components/nameGenderAgePhonenumberPiece";
import doctorInfo from "@/views/outpatientDoctorWorkstation/outpatientService/components/outpatientServiceContent/components/doctorInfo";
import medicalRecord from "@/views/outpatientDoctorWorkstation/outpatientService/components/outpatientServiceContent/components/medicalRecord";
import {post} from "@/api/api";
export default {
  name: "index",
  props:['userInfoData'],
  data() {
    return {
      saveOrupdateBtn: '0',
      patient: null,
      isEdit: false,
    };
  },

  computed:{
    isShowFinishReception () {
      return this.$hasPermission('/outpatientDoctor/medicalRecord/finishReception');
    },
    isShowAiDiagnosis () {
      return this.$hasPermission('/outpatientDoctor/medicalRecord/aiDiagnosis');
    },
    isShowSave() {
      return this.$hasPermission('/outpatientDoctor/patient/save');
    },
    getShow(){
     return this.patient && JSON.stringify(this.patient) !== "{}"
    }
  },
  watch: {
    '$store.state.nowPatientInfo':{
      handler (newValue,oldValue) {
        if (newValue) {
          this.isEdit = false
          this.patient = JSON.parse(JSON.stringify(newValue))
        } else {
          this.patient = null
        }

      },
      deep:true,
    },
  },

  components:{
    nameGenderAgePhonenumberPiece,
    doctorInfo,
    medicalRecord
  },
  mounted() {
    if (!localStorage.getItem('patientDraftList') || localStorage.getItem('patientDraftList') === '[]'){
      this.patient = null
    } else {
      if (this.$store.state.nowPatientInfo) {
        this.patient = JSON.parse(JSON.stringify(this.$store.state.nowPatientInfo))
      }
    }

    },
  methods:{
    handleBeforeUnload () {
      return this.$refs.medicalRecordRef.handleBeforeUnload()
    },
    refreshList () {
      this.$emit('refresh-list');
    },
    updateCOntent () {
      this.isEdit = true
      this.$refs.medicalRecordRef.isEdit = true
    },
   async deletDraft () {
     try {
       await this.$confirm('删除后不能恢复,确定删除该草稿?', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
       })
       // 确保 draftId 是字符串，避免类型不一致导致删除失败
       const draftId = String(this.patient.draftId)
       this.$store.commit('deletePatientDraft', draftId)
       this.$store.commit('deleteMedicalRecordDraft', draftId)

       // 立即清空当前患者信息，避免状态残留
       this.patient = null
       this.$store.state.nowPatientInfo = {}

       this.$store.state.resetList = true
       this.$emit('refresh-list')

     }catch(err) {

     }
    },
    updateUserInfo (val) {
      this.patient = val
    },
    aiDiagnosis () {
      this.$store.state.patientInfoFormRuleType === 2
      this.$refs.medicalRecordRef.aiDiagnosis()
    },
    cancelEdit () {
      this.$refs.medicalRecordRef.cancelEdit()
    },
    save () {
      this.$refs.medicalRecordRef.save().then(res => {
        console.log('savesavesave', res)
        if (res && res.data && res.data.code === 200) {
          this.$message.success('保存成功');
          // 通知父组件刷新列表
          this.$emit('refresh-list');
        } else {
          this.$message.error('保存失败1');
        }
      }).catch(err => {
        console.error(err);
      });
    },
    finishReception() {
      // 直接调用medicalRecord组件的finishReception方法，它内部会验证所有表单
      this.$refs.medicalRecordRef.finishReception().then(res => {
        if (res && res.data && res.data.code === 200) {
          this.$message.success('完成接诊成功');
          // 通知父组件刷新列表
          this.$emit('refresh-list');
        } else {
          this.$message.error('完成接诊失败');
        }
      }).catch(err => {
        // 验证失败或提交失败的错误处理已在medicalRecord组件中处理
      });
    },
    validateForm() {
      // 获取nameGenderAgePhonenumberPiece组件的引用
      const nameGenderComponent = this.$children.find(child => child.$options.name === 'index' && child.patient);
      const medicalRecordComponent = this.$refs.medicalRecordRef;

      let isValid = true;
      let message = '';

      // 验证姓名
      if (!this.patient.name || this.patient.name.trim() === '') {
        isValid = false;
        message = '姓名不能为空';
        if (nameGenderComponent) {
          nameGenderComponent.isOkUserName = false;
        }
      } else {
        if (nameGenderComponent) {
          nameGenderComponent.isOkUserName = true;
        }
      }

      // 验证年龄
      if ((!this.patient.ageYear || this.patient.ageYear === '') && (!this.patient.ageMonth || this.patient.ageMonth === '')) {
        isValid = false;
        message = message || '年龄不能为空';
        if (nameGenderComponent) {
          nameGenderComponent.isOkAge = false;
          nameGenderComponent.isOkMounth = false;
        }
      } else {
        if (nameGenderComponent) {
          nameGenderComponent.isOkAge = true;
          nameGenderComponent.isOkMounth = true;
        }
      }

      // 验证手机号（允许为空）
      if (this.patient.phoneNumber && this.patient.phoneNumber.trim() !== '') {
        // 只有当手机号不为空时才验证格式
        const phoneReg = /^(1[3-9]\d{9}|(\$\d{3,4}\$|\d{3,4}[- ]?)\d{7,8}([- ]?\d{2,4})?)$/;
        if (!phoneReg.test(this.patient.phoneNumber)) {
          isValid = false;
          message = message || '手机号格式不正确';
          if (nameGenderComponent) {
            nameGenderComponent.isOkPhoneNumber = false;
            nameGenderComponent.phoneNumberErrorType = 'format';
          }
        } else {
          if (nameGenderComponent) {
            nameGenderComponent.isOkPhoneNumber = true;
          }
        }
      } else {
        // 手机号为空时，设置为正确状态
        if (nameGenderComponent) {
          nameGenderComponent.isOkPhoneNumber = true;
        }
      }

      // 验证主诉
      if (!medicalRecordComponent.medicalRecordInfo.readme || medicalRecordComponent.medicalRecordInfo.readme.trim() === '') {
        isValid = false;
        message = message || '主诉不能为空';
        medicalRecordComponent.isOkReadme = false;
      } else {
        medicalRecordComponent.isOkReadme = true;
      }

      // 验证诊断
      if (!medicalRecordComponent.medicalRecordInfo.diagnosis || medicalRecordComponent.medicalRecordInfo.diagnosis.trim() === '') {
        isValid = false;
        message = message || '诊断不能为空';
        medicalRecordComponent.isOkDiagnosis = false;
      } else {
        medicalRecordComponent.isOkDiagnosis = true;
      }

      return { isValid, message };
    },
    setAgeError(hasError) {
      // 获取nameGenderAgePhonenumberPiece组件的引用
      const nameGenderComponent = this.$children.find(child => child.$options.name === 'index' && child.patient);
      if (nameGenderComponent) {
        nameGenderComponent.isOkAge = !hasError;
        nameGenderComponent.isOkMounth = !hasError;
      }
    },
    setGenderError(hasError) {
      // 性别错误状态设置（如果需要的话，可以在nameGenderAgePhonenumberPiece组件中添加相应的错误状态）
      // 目前性别是下拉选择，通常不会为空，但可以根据需要扩展
    }
  }
}
</script>
<style lang="less" scoped>
.outpatientServiceContent{
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  //border: 1px solid red;
  .topBar{
    height: 55px;
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    .title{
      margin-left: 15px;
      font-size: 16px;
      color: #000;
      font-weight: 700;
      display: flex;
      align-items: center;
      .deleteDraftBtn{
        margin-left: 20px;
        width: 82px;
        height: 28px;
        border-radius: 4px;
        border: 1px solid #c1c1c1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;
        background: #fff;
        transition: all 0.3s ease;
        font-size: 13px;
        &:hover{
          background: #ededed;
          color: #000;
        }
        &:active{
          background: #ededed;
          color: #000;
        }
      }
    }
    .DoBox{
      display: flex;
      align-items: center;
      gap: 15px;
      margin-right: 20px;
      .intelligentDiagnosisBtn{
        width: 82px;
        height: 32px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF;
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;
        background: #50c878;
        transition: all 0.3s ease;
        &:hover{
          background-color: #23cf67;
        }
        &:active{
          background-color: #08a446;
        }
      }
      .finishDiagnosisBtn{
        width: 82px;
        height: 32px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF;
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;
        background: #50c878;
        transition: all 0.3s ease;
        &:hover{
          background-color: #23cf67;
        }
        &:active{
          background-color: #08a446;
        }
      }
    }
  }
  .contentBox{
    position: relative;
    //top: -40px;
    z-index: 10;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin:15px 15px;
    //padding-top: 40px;
    //padding: 15px;
    //border: 1px solid red;
    height: calc(100vh - 210px);
    //overflow-y: auto;
    //overflow: visible;
    padding-bottom: 20px;
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 10px;
      background-color: transparent;
    }

    //&:hover::-webkit-scrollbar {
    //  width: 8px;
    //  background-color: rgb(230, 234, 237);
    //}

    &:hover::-webkit-scrollbar-thumb {
      background-color: rgb(228, 230, 232);
      border-radius: 10px;
    }
    .head{
      height: 40px;
      width: 100%;
      //border: 1px solid red;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .content{
      flex: 1;
      width: 100%;
      overflow-y: auto;
      //border: 1px solid #1ec761;
      //background-color: green;
    }
  }
}
</style>
